import {
  createContext,
  FC,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { useGetUserMe } from "../api/queries";
import { Company, User } from "../types";
import { useLogOut } from "../api/mutation";

interface PermissionContextType {
  user: User | undefined;
  permissions: string[];
  company: any;
  isHavePermission: (permission: string) => boolean;
}

const PermissionsContext = createContext<PermissionContextType | null>(null);

const PermissionsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { data } = useGetUserMe();
  const [user, setUser] = useState<User>();
  const [company, setCompany] = useState<Company>();
  const [userPermissions, setUserPermissions] = useState<string[]>();
  const companyType = localStorage.getItem("companyType");
  const isHavePermission = (permission: string) => {
    if (!userPermissions || !Array.isArray(userPermissions)) return false;
    return userPermissions.some((perm) => perm === permission);
  };
  const { mutate: logOut } = useLogOut();
  useMemo(() => {
    if (data) {
      if (companyType && companyType !== data?.company?.companyType) {
        logOut();
      }
      setUser(data);
      setCompany(data?.company);
      const permissionsArr = data.role.permissions.map(
        (el) => el.permission.key
      );
      setUserPermissions(permissionsArr);
    }
  }, [data, companyType]);
  return (
    <PermissionsContext.Provider
      value={{
        user,
        permissions: userPermissions || [],
        company,
        isHavePermission,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = (): PermissionContextType => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionProvider");
  }
  return context;
};
export default PermissionsProvider;
